module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/hero-f91b001abb0a753590c5b121d883d72e.jpg";